import { Colors } from "@utils";
import { GradeTextColor, HealthAgeIcon } from "@utils/Constants";
import React from "react";
import styled from "styled-components";

interface PartHealthGradeViewProps {
  part: HealthPart;
  grade: HealthGrade;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`;

const UNKNOWN_COLOR = Colors.gray2;

const PartHealthGradeView: React.FC<PartHealthGradeViewProps> = ({
  part,
  grade,
}) => {
  const color = React.useMemo(() => {
    return GradeTextColor[grade] ?? UNKNOWN_COLOR;
  }, [grade]);

  return (
    <Container>
      <div
        className="text-[14px]/[19px] font-[600] mb-[2px]"
        style={{ color: "#2A2B2C" }}
      >
        {part}건강 성적
      </div>
      <div className="text-[20px]/[28px] font-[700]" style={{ color }}>
        {grade}
      </div>
      <img
        className="self-end w-[32px] h-[32px]"
        src={HealthAgeIcon[part]}
        alt=""
      />
    </Container>
  );
};

export default PartHealthGradeView;
